module.exports = __webpack_public_path__ + "static/media/cap4-04-mob.3d8dfc57.png";